import React, { useState, useEffect } from "react";
import "../JobPosting/jobs.scss";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobById, updateJob } from "../../Redux/ActionCreators/jobsAction";

const CandidateReportSharing = ({ setType, setSnackbar }) => {
  const { jobId } = useParams();
  const dispatch = useDispatch();

  const [saveLoading, setSaveLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [enableShare, setEnableShare] = useState(false);
  const [hideDetails, setHideDetails] = useState(false);

  const job = useSelector((state) => state.jobs.latestJob);

  const initialfetch = async () => {
    if (jobId) {
      setLoading(true);
      await dispatch(fetchJobById(jobId));
      setLoading(false);
    }
  };

  useEffect(() => {
    initialfetch();
  }, [jobId]);

  useEffect(() => {
    if (job) {
      setEnableShare(job?.enable_candidate_report_share ?? false);
      setHideDetails(job?.hide_candidate_details ?? false);
    }
  }, [job]);

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSave = async () => {
    if (!jobId) return;

    setSaveLoading(true);

    const payload = {
      enable_candidate_report_share: enableShare,
      hide_candidate_details: hideDetails,
    };

    const res = await dispatch(updateJob(jobId, payload));

    setSaveLoading(false);

    if (res?.success === false) {
      showSnackbar("Failed to save settings", "error");
      return;
    }

    // SUCCESS
    showSnackbar("Settings saved successfully", "success");

    // Navigate immediately
    setType("");
  };

  return (
    <div className="job-prescreening">
      <div className="job-settings-head">
        <img
          src="/images/back-arrow-black.svg"
          alt="back"
          width={32}
          height={32}
          onClick={() => {
            setType("");
          }}
          style={{ cursor: "pointer" }}
        />
        <div className="job-settings-head-title d-flex align-items-center">
          <h3 style={{ margin: "0" }}>Candidate Report Sharing Settings</h3>
        </div>
      </div>

      <div className="job-settings-body">
        {loading ? (
          <div
            className="loading-overlay"
            style={{
              position: "relative",
              marginTop: 16,
              alignItems: "start",
              height: "32px",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="job-settings-form">
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <input
                    type="checkbox"
                    checked={enableShare}
                    onChange={(e) => {
                      const val = e.target.checked;
                      setEnableShare(val);
                      if (!val) {
                        setHideDetails(false);
                      }
                    }}
                  />
                  Enable candidate report share access
                </label>
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <input
                    type="checkbox"
                    disabled={!enableShare}
                    checked={hideDetails}
                    onChange={(e) => setHideDetails(e.target.checked)}
                  />
                  Hide candidate details in shared report
                </label>
              </div>

              <button
                className="save-btn"
                disabled={saveLoading}
                onClick={handleSave}
              >
                {saveLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CandidateReportSharing;
